<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut')
                }}</span>
            </div>
            <div>
                <div class="main_top">{{ $t('say.title') }}</div>
                <div class="main_bottom">
                    <div class="scroll">
                        <div class="dmcontent" v-show="!show">
                            <div class="dmt dmt1"></div>
                            <div class="dmt dmt2"></div>
                            <div class="dmt dmt3"></div>
                            <div class="dmt dmt4"></div>
                            <div class="dmt dmt5"></div>
                        </div>
                        <p class="show" @click="show = true">{{ $t('say.bth') }}</p>
                        <div class="setUp" v-show="show">
                            <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2022/close_icon.png" @click="show = false"
                                class="close">
                            <textarea name="danmu" id="" class="tat" maxlength="20" :placeholder="$t('say.placeholder')"
                                v-model="content"></textarea>
                            <input type="hidden" name="headimgurl" id="headimgurl" value="">
                            <input type="hidden" name="nickname" id="nickname" value="">
                            <span class="btn" @click="submit">{{ $t('say.bth') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="path('photo')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>

        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>
<script>
import menus from "../../components/menu.vue"
import {
    getMessage,
    initClose
} from '../../barrage.js'

export default {
    components: {
        menus
    },
    name: "say",
    data () {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            openid: localStorage.getItem("nissan2023_meeting_openid"),
            name: localStorage.getItem("nissan2023_meeting_name"),
            cover: localStorage.getItem("nissan2023_meeting_cover"),
            toastShow: false,
            toastText: "",
            show: false,
            content: '',
        }
    },
    created () {
        //_hmt.push(['_trackPageview', '/phone/say']);
    },
    mounted () {
        getMessage();
    },
    /* 卸载后 */
    beforeDestroy () {
        initClose();
    },
    methods: {
        alerts3 (content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        submit () {
            let that = this, data = new FormData();
            if (that.content == '') {
                that.toast(that.$t('say.tips'))
            } else {
                data.append('content', that.content);
                data.append('uuid', that.openid);
                data.append('name', that.name);
                data.append('photo', that.cover);
                data.append('sid', 'EQ6EONO1L1');
                that.axios.post('https://bulletchat.event1.cn/api/chatAdd', data).then((res) => {
                    if (res.data.code == 200) {
                        that.content = '';
                        that.toast(that.$t('back.success'));
                        that.show = false;
                    }
                })
            }
        },
        signOut () {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path (path) {
            this.$router.replace('/' + path)
        },
        toast (str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false;
                that.click = true;
            }, 1500)
        },
    }
}
</script>
<style scoped>
@import "../../assets/css/index.css";
@import "../../assets/css/common.css";

.main_bottom {
    background: #eee;
}

.scroll {
    width: 100%;
    height: 6rem;
    display: flex;
    flex-direction: column;
    perspective: 5rem;
    transform: translateZ(1px);
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1000;
}

.dmcontent {
    width: 6.24rem;
    height: 6rem;
    padding-top: 0.05rem;
    /* padding: 0.2rem 40px 60px 10px; */
    overflow: hidden;
    position: relative;
    border-radius: 0.18rem;
    z-index: 1;
}

.show {
    width: max-content;
    height: 0.8rem;
    padding: 0.2rem 0.5rem;
    background-color: #c61533;
    text-align: center;
    color: #fff;
    border-radius: 5px;
    font-size: 0.3rem;
    margin: 0.5rem auto 0;
}

.setUp {
    width: 90%;
    height: 6rem;
    position: absolute;
    bottom: -0.4rem;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    /* display: none; */
    display: flex;
    flex-direction: column;
    z-index: 2;
}

.close {
    right: -0.2rem;
    top: -0.2rem;
    width: 0.7rem;
    position: absolute
}


.tat {
    position: absolute;
    width: 75%;
    height: 2rem;
    top: 10%;
    left: 0px;
    right: 0px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.3);
    color: #fff;
    font-size: 0.27rem;
    padding: 0.08rem;
    border: 1px solid #96979f;
    border-radius: 0.1rem;
}

.btn {
    position: fixed;
    left: 50%;
    bottom: 1rem;
    transform: translateX(-50%);
    padding: .2rem .5rem;
    width: max-content;
    text-align: center;
    background-color: #c61533;
    color: #FFF;
    line-height: 13px;
    cursor: pointer;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    display: block;
    margin: 0 auto;
    font-size: .3rem;
}
</style>


// WEBPACK FOOTER //
// src/views/photo/say.vue